import { defaultTheme } from '../../../theming/data/defaultTheme'
import border from '../../../tokens/v2/border'
import colors from '../../../tokens/v2/colors'
import fonts from '../../../tokens/fonts'
import layout from '../../../tokens/v2/layout'
import styled from 'styled-components'
import { composeTheme } from '../../../utils/compose-theme'

interface ComponentProps {
  readonly active?: boolean
  readonly notification?: boolean
}

export const Icon = styled.div.attrs((props) => composeTheme(props))`
  font-size: ${(props) => props.theme.sideMenuAlt.iconFontSize};

  svg {
    fill: ${(props) => props.theme.sideMenuAlt.iconColor};
  }

  &.is-disabled {
    svg {
      fill: ${colors.gray300};
    }
  }
`

export const WrapperNotification = styled.div.attrs((props) =>
  composeTheme(props),
)`
  background-color: ${(props) =>
    props.theme.sideMenuAlt.notificationColor ||
    props.theme.brandColors.primaryPure};
  top: 1rem;
  position: absolute;
  width: ${(props) => props.theme.sideMenuAlt.notificationSize};
  height: ${(props) => props.theme.sideMenuAlt.notificationSize};
  border-radius: ${border.radius.pill};
  left: 1.4rem;
  border: ${border.width.micro} solid
    ${(props) => props.theme.sideMenuAlt.notificationBorderColor};
`

export const Item = styled.div.attrs((props) =>
  composeTheme(props),
)<ComponentProps>`
  color: ${(props) => props.theme.sideMenuAlt.color};
  font-family: ${fonts.inter};
  font-size: ${(props) => props.theme.sideMenuAlt.fontSize};
  font-weight: ${(props) => props.theme.sideMenuAlt.fontWeight};
  margin: ${layout.spacing.xmc} ${layout.spacing.none};
  padding: ${layout.spacing.xmc} ${layout.spacing.micro};
  display: flex;
  align-items: center;
  cursor: pointer;

  &.is-active,
  &:hover {
    color: ${(props) => props.theme.sideMenuAlt.activeColor};
    border-radius: ${(props) => props.theme.sideMenuAlt.activeBorderRadius};
    background-color: ${(props) => props.theme.sideMenuAlt.activeBackground};
    font-weight: ${(props) => props.theme.sideMenuAlt.activeFontWeight};

    ${Icon} {
      svg {
        fill: ${(props) => props.theme.sideMenuAlt.activeColor};
      }
    }

    ${WrapperNotification} {
      border-color: ${(props) =>
        props.theme.sideMenuAlt.notificationBorderColor};
    }
  }

  &:hover {
    transition: color 0.25s;
  }
`

export const Button = styled.button`
  align-items: center;
  background: transparent;
  border: ${border.width.none};
  color: inherit;
  cursor: pointer;
  display: flex;
  font: inherit;
  margin: ${layout.spacing.none};
  overflow: visible;
  outline: none;
  padding: ${layout.spacing.none};
  position: relative;
  text-decoration: none;
  width: auto;
  -webkit-font-smoothing: inherit;
  -moz-osx-font-smoothing: inherit;
  -webkit-appearance: none;
`

export const Text = styled.div.attrs((props) => composeTheme(props))`
  display: ${(props) => (props.theme.collapsed ? 'none' : 'inline-block')};
  text-align: left;
  margin-left: ${layout.spacing.micro};

  &.is-disabled {
    color: ${colors.gray300};
    cursor: not-allowed;
  }
`
export const TextContainer = styled.div`
  display: flex;
  width: ${(props) => (props.theme.collapsed ? '0rem' : '18rem')};
  justify-content: space-between;
`

Button.defaultProps = defaultTheme
Item.defaultProps = defaultTheme
WrapperNotification.defaultProps = defaultTheme
Text.defaultProps = defaultTheme
TextContainer.defaultProps = defaultTheme
